import {
    computed,
    Ref,
} from '@vue/composition-api';

import OfferEvent from '@core/models/offer/OfferEvent';

import { CompetitorNumber } from '../helpers';

export function useCompetitorStats(event: Ref<OfferEvent>) {
    const isTeamLeading = (firstTeamScore: number | undefined, secondTeamScore: number | undefined) => {
        if (firstTeamScore === undefined || secondTeamScore === undefined) {
            return false;
        }
        return firstTeamScore > secondTeamScore;
    };
    return {
        isLive: computed(() => event.value.isOngoing()),
        isFirstLeading: computed(() => event.value.liveData && isTeamLeading(event.value.liveData.team1Score, event.value.liveData.team2Score)),
        isSecondLeading: computed(() => event.value.liveData && isTeamLeading(event.value.liveData.team2Score, event.value.liveData.team1Score)),
        isFirstServing: computed(() => event.value.liveData?.serve === CompetitorNumber.firstCompetitor),
        isSecondServing: computed(() => event.value.liveData?.serve === CompetitorNumber.secondCompetitor),
    };
}
